<template>
  <div class="container">
    <div class="form one grg40">
      <form v-on:submit.prevent="validateAmountAndSubmit">
      <div class="input-group one grg20">
          <label for="amount">Enter the amount you wish to donate</label>
          <input type="number" min="0" step="1" id="amount" class="form-control" v-model="amount" placeholder="Enter the amount you wish to donate in rands">
      </div>
        <div class="button">
          <button type="submit" class="primary rounded jstart">Donate Now</button>
        </div>
      </form>
        <paygate-button v-if="paygate" :paygateResponse="paygateResponse" />
    </div>
  </div>
</template>

<script>
    import DonationForm from "./DonationForm";
    import Loader from "../Loader";
    import PayfastButton from "./PayfastButton";
    import PaypalButton from "./PaypalButton";
    import PaygateButton from "./PaygateButton";

    export default {
      name: "MiniDonationPage",
      props: {
        campaign_id: {
          type: Number,
          default: 1
        },
        person: {
          type: Object,
          required: true
        },
        donation: {
          type: Object,
          required: true
        }
      },
      components: {
        DonationForm,
        Loader,
        PayfastButton,
        PaypalButton,
        PaygateButton
      },
      data: () => ({
        loading: false,
        payfastButtonResponse: undefined,
        showForm: true,
        paygate: false,
        paygateResponse: undefined,
        amount: null,
      }),
      methods: {
        validateAmountAndSubmit() {
          if (this.amount > 0) {
            this.donation.dedicate = "0";
            this.donation.dedicate_first_name = "";
            this.donation.dedicate_last_name = "";
            this.donation.first_name = this.person.first_name;
            this.donation.last_name = this.person.last_name;
            this.donation.email = this.person.email;
            this.donation.anonymous = false;
            this.donation.phone_number = this.person.phone_number;
            this.donation.comment = "";
            this.donation.amount = this.amount;
            this.donation.recurring = "0";
            this.donation.iteration_date = "";
            this.donation.payment_country = "ZAR";
            this.donation.original_amount = this.amount;
            this.donation.dedicate_type = "1";
            this.donation.campaign_id = this.campaign_id;
            this.donation.payment_method = "paygate";
            this.donation.final_rate = 1;
            this.donation.sub_campaign_id = "1";
            this.$swal.fire({
              icon: 'info',
              title: 'Validating your information...',
              allowOutsideClick: false,
              allowEscapeKey: false,
              showConfirmButton: false,
              backdrop: `rgba(0, 0, 0, 0.7)`,
              imageAlt: 'Custom image',
              onBeforeOpen: () => {
                this.$swal.showLoading();
                this.checkWithServer();
              }
            });
          } else {
            this.$swal.fire({
              icon: 'error',
              title: 'Please enter a valid amount',
              backdrop: `rgba(0, 0, 0, 0.7)`,
              imageAlt: 'Custom image',
            });
          }
        },
        formSubmittedSuccessfully(data) {
          this.paygate = true;
          this.paygateResponse = data;
        },
        checkWithServer() {
          axios.post('/api/submitDonation', this.donation).then(response => {
            this.showPaygateModal();
            setTimeout(() => {
              this.formSubmittedSuccessfully(response.data);
            }, 2000);
          }).catch(error => {
            console.log(error);
            this.$swal.close();
            if (error.response.status === 422) {
              this.showInvalidData(error);
            }
            if (error.response.status === 500) {
              this.showPayGateError();
            }
            this.loading = false;
            this.errors = error.response.data;
          });
        },
        showPaygateModal() {
          this.$swal.fire({
            icon: 'success',
            title: 'Transferring you to our trusted payment partner, DPO Paygate',
            imageUrl: '/img/collage.png',
            allowOutsideClick: false,
            allowEscapeKey: false,
            showConfirmButton: false,
            // imageWidth: 593,
            // imageHeight: 95,
            backdrop: `rgba(0,0,0,0.7)`,
            imageAlt: 'Custom image',
            onOpen:  () => {
              this.$swal.showLoading();
            }
          });
        },
      },
      mounted() {
        this.$on('my-event', function() {
          console.log('bob');
        })
      }
    }
</script>

<style scoped>

</style>
